import SingleCustomer from './SingleCustomer';

export default SingleCustomer;
